import { render, staticRenderFns } from "./InconsistencesView.vue?vue&type=template&id=28dd9fa8&scoped=true&"
import script from "./InconsistencesView.vue?vue&type=script&lang=js&"
export * from "./InconsistencesView.vue?vue&type=script&lang=js&"
import style0 from "./InconsistencesView.vue?vue&type=style&index=0&id=28dd9fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd9fa8",
  null
  
)

export default component.exports